exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fix{margin-top:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-1529614c!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FormExport.vue
// module id = 848
// module chunks = 2